import React, { useState, useEffect } from 'react';
import { Link, withRouter, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    TextField,
    Button,
    CircularProgress
} from '@material-ui/core';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import IntlMessages from 'util/IntlMessages';
import { startLoader } from 'actions/general.action';
import { setUserPassword } from 'actions/users.action';
import { validatePassword } from 'util/commonFunc';

const SetPassword = (props) => {
    const history = useHistory();
    const { token } = props.match.params;
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState({
        password: '',
        confirmPassword: ''
    });
    const dispatch = useDispatch();
    const { loader, alertMessage, showMessage } = useSelector(({ general }) => general);
    const { setPasswordStatus }  = useSelector(({ users_r }) => users_r);

    useEffect(() => {
        if ( setPasswordStatus ) {
            history.push('/signin');
        }
    }, [setPasswordStatus]);

    return (
        <div
            className="app-login-container d-flex justify-content-center align-items-center"
        >
            {
                !loader ? 
                    <div className="app-login-main-content">
                        <div className="app-logo-content d-flex align-items-center justify-content-center">
                            <Link className="logo-lg" to="/" title="odoc">
                                <img src={require("assets/images/logo.png")} alt="odoc" title="odoc" />
                            </Link>
                        </div>
                        <div className="app-login-content">
                            <div className="app-login-header mb-3">
                                <h1><IntlMessages id="appModule.changePassword" /></h1>
                            </div>

                            <div className="app-login-form">
                                <div>
                                    <center>
                                        {
                                            "Password must contain atleast one lowercase letter, " + 
                                            "one uppercase letter, one numeric digit, one special character " +
                                            "and be atleast 8 characters long."
                                        }
                                    </center>
                                </div>
                                <form>
                                    <fieldset>
                                        <TextField
                                            type="password"
                                            label={<IntlMessages id="appModule.password" />}
                                            fullWidth
                                            onChange={(event) => setPassword(event.target.value)}
                                            defaultValue={password}
                                            margin="normal"
                                            className="mt-1 my-sm-3"
                                            error={!!error.password}
                                            helperText={error.password}
                                        />
                                        <TextField
                                            type="password"
                                            label={<IntlMessages id="appModule.confirmPassword" />}
                                            fullWidth
                                            onChange={(event) => setConfirmPassword(event.target.value)}
                                            defaultValue={confirmPassword}
                                            margin="normal"
                                            className="mt-1 my-sm-3"
                                            error={!!error.confirmPassword}
                                            helperText={error.confirmPassword}
                                        />

                                        <div className="mb-3 mt-3 d-flex align-items-center justify-content-between">
                                            <Button 
                                                onClick={() => {
                                                    let validateMsg = validatePassword(
                                                        password, 
                                                        confirmPassword, 
                                                        true
                                                    );

                                                    if (validateMsg.passwordErr) {
                                                        setError({
                                                            password: validateMsg.passwordErr,
                                                            confirmPassword: ''
                                                        });
                                                    } else if (validateMsg.confirmPasswordErr) {
                                                        setError({
                                                            password: '',
                                                            confirmPassword: validateMsg.confirmPasswordErr
                                                        });
                                                    } else {
                                                        dispatch(startLoader());
                                                        dispatch(setUserPassword({
                                                            password,
                                                            token: token
                                                        }));
                                                    }
                                                }}
                                                variant="contained" 
                                                color="primary"
                                            >
                                                <IntlMessages id="appModule.submit" />
                                            </Button>
                                        </div>
                                    </fieldset>
                                </form>
                            </div>
                        </div>
                    </div> :
                    <div className="loader-view">
                        <CircularProgress />
                    </div>
            }
            {
                showMessage && 
                NotificationManager.error(alertMessage)
            }
            <NotificationContainer />
        </div>
  );
};


export default withRouter(SetPassword);
